import '@innovatrics/dot-face-auto-capture';
import type { FaceConfiguration, HTMLFaceCaptureElement } from '@innovatrics/dot-face-auto-capture';

import { memo, useEffect } from 'react';

/*
 * When component is initialized, wasm directory will be fetched from http://localhost:3000/wasm.
 * That's why wasm directory need to be placed in root of public directory.
 */

const FaceCameraInner = (props: FaceConfiguration) => {
  useEffect(() => {
    // 2. Init existed custom web-component
    const faceAutoCaptureHTMLElement = document.getElementById(
      'x-dot-face-auto-capture',
    ) as HTMLFaceCaptureElement | null;

    if (faceAutoCaptureHTMLElement) {
      faceAutoCaptureHTMLElement.configuration = props;
    }
  });

  // 1. Return empty custom web-component html TAG
  return <x-dot-face-auto-capture id="x-dot-face-auto-capture" />;
};

export const FaceCamera = memo(FaceCameraInner);
